import { User } from '../../common/types'
import {
  ActionTypes,
  HideSocketMessages,
  SetCurrentUserAction,
  SetMessageCount,
  SetOfflineModeAction,
  SetUnSavedJobCount,
  ShowSocketMessages,
} from './types'

export function setCurrentUser(user: User): SetCurrentUserAction {
  return {
    type: ActionTypes.SET_CURRENT_USER,
    value: user,
  }
}

export function setOfflineMode(value: boolean): SetOfflineModeAction {
  return {
    type: ActionTypes.SET_OFFLINE_MODE,
    value,
  }
}

export function showSocketModal(): ShowSocketMessages {
  return {
    type: ActionTypes.SHOW_SOCKET_MESSAGES,
    value: true,
  }
}

export function hideSocketModal(): HideSocketMessages {
  return {
    type: ActionTypes.HIDE_SOCKET_MESSAGES,
    value: false,
  }
}

export function setUnSavedJobCount(count: number): SetUnSavedJobCount {
  const value: number = count < 0 ? 0 : count
  return {
    type: ActionTypes.SET_UN_SAVED_JOB_COUNT,
    value,
  }
}
export function setMessageCount(count: number): SetMessageCount {
  const value: number = count < 0 ? 0 : count
  return {
    type: ActionTypes.SET_MESSAGE_COUNT,
    value,
  }
}
